import React from 'react';
import PropTypes from 'prop-types';


const Commitment = ({subtitle, text}) => {
  return (
      <div className={'bg-wrapper'}>
        <h4 className='subtitle'>{subtitle}</h4>
        <p className={'text'}>{text}</p>
        <div className="spr2 gia"/>
      </div>
  )
};

Commitment.propTypes = {
  text:PropTypes.string,
  subtitle:PropTypes.string
};

export default Commitment;